// Loads data about a character from Lodestone and injects it into the webpage.

import { getCharacter } from "./lodestone";
import { getId } from "./util";
import { updateJobText } from "./jobs";

// Data should be shaped by the Lodestone class, this class is more about view management.
class CharacterData {
  state = {
    inProgress: false,
    lodestoneId: '',
    rawData: {},
  }

  elements = {
    cardBio: getId("cardBio"),
    cardFooter: getId("cardFooter"),
    cardSig: getId("cardSig"),
    cardTitle: getId("cardTitle"),
    loadingImg: getId("loadingImg"),
    lodeError: getId("lodeError"),
    settingsBody: getId("settingsBody"),
    settingsName: getId("settingsName"),
    settingsPronounDC: getId("settingsPronounDC"),
  };

  constructor(data = {}) {
    this.state.lodestoneId = data.lodestoneId || '';
    this.state.rawData = data.rawData || {};
  }

  load = async (lodestoneId) => {
    if (this.state.inProgress || isNaN(lodestoneId) || lodestoneId === "") {
      return;
    }

    console.log(`Loading ${lodestoneId} from Lodestone`);
    this.toggleInProgress();
    this.state.lodestoneId = lodestoneId;
    this.state.rawData = await getCharacter(lodestoneId);
    
    if (this.state.rawData.status === "success") {
      this.reloadFields();
    } else {
      this.handleLoadError();
    }

    this.toggleInProgress();
    return this;
  };

  jobs = () => (this.state.rawData.jobs);

  lodestoneId = () => (this.state.lodestoneId);

  title = (locale) => {
    if (!(this.state.rawData && this.state.rawData.title))
      return;

    const title = this.state.rawData.title;
    if (typeof title === 'string')
      return title;
    else
      return title[locale];
  };

  toggleInProgress = () => {
    if (this.state.inProgress) {
      this.state.inProgress = false;
      this.elements.loadingImg.style.display = "none";
      document.body.style.cursor = "auto";
    } else {
      this.state.inProgress = true;
      document.body.style.cursor = "progress";
      this.elements.loadingImg.style.display = "flex";
      this.elements.lodeError.style.display = "none";
    }
  };

  //call this to update all prefills
  reloadFields = () => {
    //open
    this.elements.settingsBody._x_dataStack[0].open = true;

    //title on card
    this.elements.cardTitle.textContent = this.title(window.AlpineI18n.locale);

    //name
    this.elements.settingsName.value = this.state.rawData.name;
    this.elements.settingsName.dispatchEvent(new Event("input", {}));

    //server
    this.elements.settingsPronounDC._x_dataStack[0].server = this.state.rawData.server;
    this.elements.settingsPronounDC._x_dataStack[0].pronoun = "";

    //bio
    this.elements.cardBio.textContent = "";
    this.elements.cardFooter.style.display = "none";

    //sig
    this.elements.cardSig.children[0].textContent = "";

    //levels
    updateJobText();
  };

  handleLoadError = () => {
    const errorMsg = this.state.rawData.status === "error" ?
      "Having trouble loading data, check your ID!" :
      "Having trouble contacting server, try again in a bit!";

    this.elements.lodeError.textContent = errorMsg;
    this.elements.lodeError.style.display = "block";
  }
}

export default CharacterData;
